/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminProExportResponse,
  AdminProMatchDataResponse,
  AdminProfessionalResponse,
  DisableUserRequest,
  GetAdminProfessionalsParams,
  GetCohortsByClientsParams,
  GetCohortsByClientsResponse,
  GetProsMatchingDataParams,
  GetUserExportDataParams,
  HTTPValidationError,
  ReviewProData,
  SrcRoutersAdminProfessionalsUpdateApplicationStatusRequest,
  UpdateCohortRequest,
  UpdateEmailVerificationRequest,
  UpdateStatusBatchRequest,
} from './platformapi.schemas';

import getAdminProfessionalsMutator from '../custom-axios-instance';
import getCohortsByClientsMutator from '../custom-axios-instance';
import disableProUserMutator from '../custom-axios-instance';
import getUserExportDataMutator from '../custom-axios-instance';
import getProsMatchingDataMutator from '../custom-axios-instance';
import getProfessionalReviewDataMutator from '../custom-axios-instance';
import updateProApplicationStatusMutator from '../custom-axios-instance';
import updateProApplicationStatusBatchMutator from '../custom-axios-instance';
import updateCohortMutator from '../custom-axios-instance';
import updateEmailVerificationMutator from '../custom-axios-instance';

/**
 * Fetch list of professionals with pagination, sorting and filtering applied. Returns the list as well as the total count of professionals matching the filter criteria.
 * @summary Get Admin Professionals
 */
export const getAdminProfessionals = (
  params?: GetAdminProfessionalsParams,
  signal?: AbortSignal,
) => {
  return getAdminProfessionalsMutator<AdminProfessionalResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/professionals/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetAdminProfessionalsQueryKey = (params?: GetAdminProfessionalsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/professionals/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAdminProfessionalsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminProfessionals>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminProfessionalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminProfessionals>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminProfessionalsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminProfessionals>>> = ({ signal }) =>
    getAdminProfessionals(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminProfessionals>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAdminProfessionalsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminProfessionals>>
>;
export type GetAdminProfessionalsQueryError = void | HTTPValidationError;

export function useGetAdminProfessionals<
  TData = Awaited<ReturnType<typeof getAdminProfessionals>>,
  TError = void | HTTPValidationError,
>(
  params: undefined | GetAdminProfessionalsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminProfessionals>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProfessionals>>,
          TError,
          Awaited<ReturnType<typeof getAdminProfessionals>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAdminProfessionals<
  TData = Awaited<ReturnType<typeof getAdminProfessionals>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminProfessionalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminProfessionals>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProfessionals>>,
          TError,
          Awaited<ReturnType<typeof getAdminProfessionals>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAdminProfessionals<
  TData = Awaited<ReturnType<typeof getAdminProfessionals>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminProfessionalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminProfessionals>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Admin Professionals
 */

export function useGetAdminProfessionals<
  TData = Awaited<ReturnType<typeof getAdminProfessionals>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminProfessionalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminProfessionals>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAdminProfessionalsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get all corporate clients and their cohort names and ids.
 * @summary Get Cohorts By Clients
 */
export const getCohortsByClients = (params?: GetCohortsByClientsParams, signal?: AbortSignal) => {
  return getCohortsByClientsMutator<GetCohortsByClientsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/professionals/corporate_clients`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetCohortsByClientsQueryKey = (params?: GetCohortsByClientsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/professionals/corporate_clients`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCohortsByClientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCohortsByClients>>,
  TError = void | HTTPValidationError,
>(
  params?: GetCohortsByClientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCohortsByClients>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCohortsByClientsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCohortsByClients>>> = ({ signal }) =>
    getCohortsByClients(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCohortsByClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCohortsByClientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCohortsByClients>>
>;
export type GetCohortsByClientsQueryError = void | HTTPValidationError;

export function useGetCohortsByClients<
  TData = Awaited<ReturnType<typeof getCohortsByClients>>,
  TError = void | HTTPValidationError,
>(
  params: undefined | GetCohortsByClientsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCohortsByClients>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCohortsByClients>>,
          TError,
          Awaited<ReturnType<typeof getCohortsByClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCohortsByClients<
  TData = Awaited<ReturnType<typeof getCohortsByClients>>,
  TError = void | HTTPValidationError,
>(
  params?: GetCohortsByClientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCohortsByClients>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCohortsByClients>>,
          TError,
          Awaited<ReturnType<typeof getCohortsByClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCohortsByClients<
  TData = Awaited<ReturnType<typeof getCohortsByClients>>,
  TError = void | HTTPValidationError,
>(
  params?: GetCohortsByClientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCohortsByClients>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Cohorts By Clients
 */

export function useGetCohortsByClients<
  TData = Awaited<ReturnType<typeof getCohortsByClients>>,
  TError = void | HTTPValidationError,
>(
  params?: GetCohortsByClientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCohortsByClients>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCohortsByClientsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Disable a professional user by updating role, plan data, cohort membership and pending match data. User will no longer have access to the platform beyond a static page informing them of this status.
 * @summary Disable Pro User
 */
export const disableProUser = (disableUserRequest: DisableUserRequest, signal?: AbortSignal) => {
  return disableProUserMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/professionals/disable_user`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: disableUserRequest,
    signal,
  });
};

export const getDisableProUserMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disableProUser>>,
    TError,
    { data: DisableUserRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disableProUser>>,
  TError,
  { data: DisableUserRequest },
  TContext
> => {
  const mutationKey = ['disableProUser'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disableProUser>>,
    { data: DisableUserRequest }
  > = (props) => {
    const { data } = props ?? {};

    return disableProUser(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisableProUserMutationResult = NonNullable<Awaited<ReturnType<typeof disableProUser>>>;
export type DisableProUserMutationBody = DisableUserRequest;
export type DisableProUserMutationError = void | HTTPValidationError;

/**
 * @summary Disable Pro User
 */
export const useDisableProUser = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof disableProUser>>,
      TError,
      { data: DisableUserRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof disableProUser>>,
  TError,
  { data: DisableUserRequest },
  TContext
> => {
  const mutationOptions = getDisableProUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns the same list of users as get_admin_professionals with additional data points used for corporate client reviews. Applies the same filter but ignores pagination and sorting.
 * @summary Get User Export Data
 */
export const getUserExportData = (params?: GetUserExportDataParams, signal?: AbortSignal) => {
  return getUserExportDataMutator<AdminProExportResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/professionals/export_data`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetUserExportDataQueryKey = (params?: GetUserExportDataParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/professionals/export_data`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUserExportDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserExportData>>,
  TError = void | HTTPValidationError,
>(
  params?: GetUserExportDataParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExportData>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserExportDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserExportData>>> = ({ signal }) =>
    getUserExportData(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserExportData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserExportDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserExportData>>
>;
export type GetUserExportDataQueryError = void | HTTPValidationError;

export function useGetUserExportData<
  TData = Awaited<ReturnType<typeof getUserExportData>>,
  TError = void | HTTPValidationError,
>(
  params: undefined | GetUserExportDataParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExportData>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserExportData>>,
          TError,
          Awaited<ReturnType<typeof getUserExportData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserExportData<
  TData = Awaited<ReturnType<typeof getUserExportData>>,
  TError = void | HTTPValidationError,
>(
  params?: GetUserExportDataParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExportData>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserExportData>>,
          TError,
          Awaited<ReturnType<typeof getUserExportData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserExportData<
  TData = Awaited<ReturnType<typeof getUserExportData>>,
  TError = void | HTTPValidationError,
>(
  params?: GetUserExportDataParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExportData>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get User Export Data
 */

export function useGetUserExportData<
  TData = Awaited<ReturnType<typeof getUserExportData>>,
  TError = void | HTTPValidationError,
>(
  params?: GetUserExportDataParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExportData>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserExportDataQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a reduced version of the my projects data for a provided professional id
 * @summary Get Pros Matching Data
 */
export const getProsMatchingData = (params: GetProsMatchingDataParams, signal?: AbortSignal) => {
  return getProsMatchingDataMutator<AdminProMatchDataResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/professionals/matching`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetProsMatchingDataQueryKey = (params: GetProsMatchingDataParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/professionals/matching`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetProsMatchingDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getProsMatchingData>>,
  TError = void | HTTPValidationError,
>(
  params: GetProsMatchingDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProsMatchingData>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProsMatchingDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProsMatchingData>>> = ({ signal }) =>
    getProsMatchingData(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProsMatchingData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetProsMatchingDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProsMatchingData>>
>;
export type GetProsMatchingDataQueryError = void | HTTPValidationError;

export function useGetProsMatchingData<
  TData = Awaited<ReturnType<typeof getProsMatchingData>>,
  TError = void | HTTPValidationError,
>(
  params: GetProsMatchingDataParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProsMatchingData>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProsMatchingData>>,
          TError,
          Awaited<ReturnType<typeof getProsMatchingData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProsMatchingData<
  TData = Awaited<ReturnType<typeof getProsMatchingData>>,
  TError = void | HTTPValidationError,
>(
  params: GetProsMatchingDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProsMatchingData>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProsMatchingData>>,
          TError,
          Awaited<ReturnType<typeof getProsMatchingData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProsMatchingData<
  TData = Awaited<ReturnType<typeof getProsMatchingData>>,
  TError = void | HTTPValidationError,
>(
  params: GetProsMatchingDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProsMatchingData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Pros Matching Data
 */

export function useGetProsMatchingData<
  TData = Awaited<ReturnType<typeof getProsMatchingData>>,
  TError = void | HTTPValidationError,
>(
  params: GetProsMatchingDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProsMatchingData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetProsMatchingDataQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Professional Review Data
 */
export const getProfessionalReviewData = (userId: number, signal?: AbortSignal) => {
  return getProfessionalReviewDataMutator<ReviewProData>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/professionals/review/${userId}`,
    method: 'GET',
    signal,
  });
};

export const getGetProfessionalReviewDataQueryKey = (userId: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/admin/professionals/review/${userId}`] as const;
};

export const getGetProfessionalReviewDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfessionalReviewData>>,
  TError = void | HTTPValidationError,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalReviewData>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProfessionalReviewDataQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfessionalReviewData>>> = ({
    signal,
  }) => getProfessionalReviewData(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfessionalReviewData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetProfessionalReviewDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProfessionalReviewData>>
>;
export type GetProfessionalReviewDataQueryError = void | HTTPValidationError;

export function useGetProfessionalReviewData<
  TData = Awaited<ReturnType<typeof getProfessionalReviewData>>,
  TError = void | HTTPValidationError,
>(
  userId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalReviewData>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfessionalReviewData>>,
          TError,
          Awaited<ReturnType<typeof getProfessionalReviewData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProfessionalReviewData<
  TData = Awaited<ReturnType<typeof getProfessionalReviewData>>,
  TError = void | HTTPValidationError,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalReviewData>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfessionalReviewData>>,
          TError,
          Awaited<ReturnType<typeof getProfessionalReviewData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProfessionalReviewData<
  TData = Awaited<ReturnType<typeof getProfessionalReviewData>>,
  TError = void | HTTPValidationError,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalReviewData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Professional Review Data
 */

export function useGetProfessionalReviewData<
  TData = Awaited<ReturnType<typeof getProfessionalReviewData>>,
  TError = void | HTTPValidationError,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalReviewData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetProfessionalReviewDataQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update the status of a professional from a simple string enum to the tangled mess of roles, types and string columns
 * @summary Update Pro Application Status
 */
export const updateProApplicationStatus = (
  srcRoutersAdminProfessionalsUpdateApplicationStatusRequest: SrcRoutersAdminProfessionalsUpdateApplicationStatusRequest,
  signal?: AbortSignal,
) => {
  return updateProApplicationStatusMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/professionals/update_application_status`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: srcRoutersAdminProfessionalsUpdateApplicationStatusRequest,
    signal,
  });
};

export const getUpdateProApplicationStatusMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProApplicationStatus>>,
    TError,
    { data: SrcRoutersAdminProfessionalsUpdateApplicationStatusRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProApplicationStatus>>,
  TError,
  { data: SrcRoutersAdminProfessionalsUpdateApplicationStatusRequest },
  TContext
> => {
  const mutationKey = ['updateProApplicationStatus'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProApplicationStatus>>,
    { data: SrcRoutersAdminProfessionalsUpdateApplicationStatusRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateProApplicationStatus(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProApplicationStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProApplicationStatus>>
>;
export type UpdateProApplicationStatusMutationBody =
  SrcRoutersAdminProfessionalsUpdateApplicationStatusRequest;
export type UpdateProApplicationStatusMutationError = void | HTTPValidationError;

/**
 * @summary Update Pro Application Status
 */
export const useUpdateProApplicationStatus = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateProApplicationStatus>>,
      TError,
      { data: SrcRoutersAdminProfessionalsUpdateApplicationStatusRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateProApplicationStatus>>,
  TError,
  { data: SrcRoutersAdminProfessionalsUpdateApplicationStatusRequest },
  TContext
> => {
  const mutationOptions = getUpdateProApplicationStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates status of multiple professional users
 * @summary Update Pro Application Status Batch
 */
export const updateProApplicationStatusBatch = (
  updateStatusBatchRequest: UpdateStatusBatchRequest,
  signal?: AbortSignal,
) => {
  return updateProApplicationStatusBatchMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/professionals/update_application_status/batch`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateStatusBatchRequest,
    signal,
  });
};

export const getUpdateProApplicationStatusBatchMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProApplicationStatusBatch>>,
    TError,
    { data: UpdateStatusBatchRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProApplicationStatusBatch>>,
  TError,
  { data: UpdateStatusBatchRequest },
  TContext
> => {
  const mutationKey = ['updateProApplicationStatusBatch'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProApplicationStatusBatch>>,
    { data: UpdateStatusBatchRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateProApplicationStatusBatch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProApplicationStatusBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProApplicationStatusBatch>>
>;
export type UpdateProApplicationStatusBatchMutationBody = UpdateStatusBatchRequest;
export type UpdateProApplicationStatusBatchMutationError = void | HTTPValidationError;

/**
 * @summary Update Pro Application Status Batch
 */
export const useUpdateProApplicationStatusBatch = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateProApplicationStatusBatch>>,
      TError,
      { data: UpdateStatusBatchRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateProApplicationStatusBatch>>,
  TError,
  { data: UpdateStatusBatchRequest },
  TContext
> => {
  const mutationOptions = getUpdateProApplicationStatusBatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update the cohort of a professional user.
 * @summary Update Cohort
 */
export const updateCohort = (updateCohortRequest: UpdateCohortRequest, signal?: AbortSignal) => {
  return updateCohortMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/professionals/update_cohort`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateCohortRequest,
    signal,
  });
};

export const getUpdateCohortMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCohort>>,
    TError,
    { data: UpdateCohortRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCohort>>,
  TError,
  { data: UpdateCohortRequest },
  TContext
> => {
  const mutationKey = ['updateCohort'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCohort>>,
    { data: UpdateCohortRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateCohort(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCohortMutationResult = NonNullable<Awaited<ReturnType<typeof updateCohort>>>;
export type UpdateCohortMutationBody = UpdateCohortRequest;
export type UpdateCohortMutationError = void | HTTPValidationError;

/**
 * @summary Update Cohort
 */
export const useUpdateCohort = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCohort>>,
      TError,
      { data: UpdateCohortRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCohort>>,
  TError,
  { data: UpdateCohortRequest },
  TContext
> => {
  const mutationOptions = getUpdateCohortMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Verify email for a professional user.
 * @summary Update Email Verification
 */
export const updateEmailVerification = (
  updateEmailVerificationRequest: UpdateEmailVerificationRequest,
  signal?: AbortSignal,
) => {
  return updateEmailVerificationMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/professionals/verify_email`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateEmailVerificationRequest,
    signal,
  });
};

export const getUpdateEmailVerificationMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailVerification>>,
    TError,
    { data: UpdateEmailVerificationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmailVerification>>,
  TError,
  { data: UpdateEmailVerificationRequest },
  TContext
> => {
  const mutationKey = ['updateEmailVerification'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmailVerification>>,
    { data: UpdateEmailVerificationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateEmailVerification(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmailVerificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmailVerification>>
>;
export type UpdateEmailVerificationMutationBody = UpdateEmailVerificationRequest;
export type UpdateEmailVerificationMutationError = void | HTTPValidationError;

/**
 * @summary Update Email Verification
 */
export const useUpdateEmailVerification = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEmailVerification>>,
      TError,
      { data: UpdateEmailVerificationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEmailVerification>>,
  TError,
  { data: UpdateEmailVerificationRequest },
  TContext
> => {
  const mutationOptions = getUpdateEmailVerificationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
